var map = {
	"./core/Drawer.vue": "41c0",
	"./core/Filter.vue": "b2ab",
	"./core/Footer.vue": "7a74",
	"./core/Toolbar.vue": "d23b",
	"./core/View.vue": "9306",
	"./material/Card.vue": "e3a9",
	"./material/ChartCard.vue": "78d5",
	"./material/Notification.vue": "9d6c",
	"./material/StatsCard.vue": "42e7",
	"./setup/training/course-material-types/DialogDelete.vue": "d50d",
	"./setup/training/course-material-types/DialogEdit.vue": "74bc",
	"./setup/training/course-material-types/DialogRestore.vue": "6492",
	"./setup/training/course-materials/ContainerView.vue": "9258",
	"./setup/training/course-materials/DialogCreate.vue": "23f0",
	"./setup/training/course-materials/DialogDelete.vue": "5d36",
	"./setup/training/course-materials/DialogEdit.vue": "8ee2",
	"./setup/training/course-materials/DialogRestore.vue": "fa6e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c68";